import { EvtHeader } from "components/header";
import React from "react";
import QuestionForm from "../form";

const CreateQuestion = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Question" />
      <div className="p-6 max-w-2xl">
        <QuestionForm />
      </div>
    </div>
  );
};

export default CreateQuestion;
